import React, { useEffect, useRef, useState } from 'react';
import { Card, Loader, Search } from 'src/components';
import { DashboardLayout } from 'src/containers';

import useFetch from 'src/hooks/useFetch';
import Button from 'src/components/button';
import Service from 'src/setup/network';
import Title from 'src/components/title';
import Description from 'src/components/Description';
import ReactToPrint from 'react-to-print';
import { BsArrowLeft } from 'react-icons/bs';
import DateFormat from 'src/components/DateFormat';
import { useLocation, useNavigate } from 'react-router-dom';
import { shiftSuccess } from 'src/redux/action/shifts.action';
import { useDispatch } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { useSelector } from 'react-redux';

const Shift: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const componentRef: any = useRef();
  const [singleShiftData, setSingleShiftData] = useState<any>([]);
  const dispatch: any = useDispatch();
  const auth = useSelector(({ authReducer }: RootState) => authReducer);

  useEffect(() => {
    if (!location?.state) {
      if (!auth.role) {
        return navigate('/');
      }
      if (auth.role === 'admin') {
        return navigate('/');
      }
      if (auth.role !== 'admin') {
        return navigate('/dine-in');
      }
    } else {
      setSingleShiftData(location.state);
    }
  }, [location]);

  useEffect(() => {
    return () => {
      dispatch(shiftSuccess(false));
    };
  }, []);

  return (
    <>
      <div className="w-full h-ful  ">
        <div className="flex items-center justify-end space-x-4">
          <div
            className="flex flex-row gap-3 items-center cursor-pointer text-black mr-auto"
            onClick={() => {
              navigate('/dine-in');
            }}
          >
            <BsArrowLeft fontSize={20} />
            <div className="font-Outfit font-semibold text-[20px] leading-[32px]">
              {'Dashboard'}
            </div>
          </div>

          <ReactToPrint
            trigger={() => <Button text="Print Report" />}
            content={() => componentRef.current}
          />
        </div>
        <div ref={componentRef} className="ml-4">
          <div className="mt-4 text-[black]">
            <p>
              <span className="mr-1">Opened at: </span>
              {singleShiftData?.openedAt && (
                <DateFormat text={singleShiftData?.openedAt ?? ''} />
              )}
            </p>
            <p className="mt-3">
              {' '}
              <span className="mr-1">Closed at: </span>
              <DateFormat text={singleShiftData?.closedAt ?? ''} />
            </p>
          </div>
          <div className="mt-4 w-[30%]">
            <Title text="Cash Drawer" className="mb-4 font-bold" />
            {singleShiftData?.cashDrawerInfo ? (
              <Card className="text-black">
                <Description
                  text="Opening Float"
                  data={singleShiftData?.cashDrawerInfo?.openingFloat}
                />
                <Description
                  text="Cash Payments"
                  data={singleShiftData?.cashDrawerInfo?.cashPayments}
                />
                <Description
                  text="Cash Refunds"
                  data={singleShiftData?.cashDrawerInfo?.cashRefunds}
                />
                <Description
                  text="Cash In"
                  data={singleShiftData?.cashDrawerInfo?.cashIn}
                />
                <Description
                  text="Cash Out"
                  data={singleShiftData?.cashDrawerInfo?.cashOut}
                  className="border-b border-border-color pb-4"
                />
                <Description
                  text="Expected Cash Amount"
                  data={singleShiftData?.cashDrawerInfo?.expectedCash}
                  className="font-bold"
                />
                <Description
                  text="Actual Cash Amount"
                  data={singleShiftData?.cashDrawerInfo?.actualCash}
                  className="font-bold"
                />
                <Description
                  text="Difference"
                  data={singleShiftData?.cashDrawerInfo?.difference}
                  className="font-bold"
                />
              </Card>
            ) : (
              <></>
            )}
          </div>

          <div className="mt-6 w-[30%] pb-8">
            <Title text="Sales Summary" className="mb-4 font-bold" />
            <Card className="text-[black]">
              <Description
                text="Gross Sales"
                data={singleShiftData?.salesSummary?.grossSales}
              />
              <Description
                text="Refunds"
                data={singleShiftData?.salesSummary?.refundsTotal}
              />
              <Description
                text="Discounts"
                data={singleShiftData?.salesSummary?.discountsTotal}
              />
              <Description
                text="Extra Charge"
                data={singleShiftData?.cashDrawerInfo?.openingFloat}
                className="border-b border-border-color pb-4"
              />
              <Description
                text="Net Sales"
                data={singleShiftData?.salesSummary?.netSales}
                className="font-bold"
              />
              {singleShiftData?.salesSummary?.salesByOrigin.map(
                (originItem: any) => {
                  const origin = Object.keys(originItem)[0];
                  const { name, total } = originItem[origin];
                  return <Description key={origin} text={name} data={total} />;
                }
              )}
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(Shift);
